module.exports = __webpack_public_path__ + "assets/img/introduction_02.a431485e.png";